import React, { useEffect, useState } from "react";

const Checkbox = props => {
  const toggleChecked = () => {
    props.setChecked(!props.checked);
  };

  const composeStateClasses = core => {
    let result = core;

    if (props.checked) {
      result += " is-checked";
    } else {
      result += " is-unchecked";
    }

    return result;
  };

  const cl = composeStateClasses("ui-checkbox-btn");
  return (
    <div className={cl} onClick={toggleChecked}>
      <input
        className="ui ui-checkbox"
        type="checkbox"
        checked={props.checked}
        onChange={() => console.log("checked")}
      />
      <label className="text">{props.children}</label>
    </div>
  );
};

export default Checkbox;
